import axios, { AxiosError } from 'axios'

const handleErrors = (error: AxiosError) => {
  switch (error?.response?.status) {
    case 401:
      console.error('401 - Não autorizado')
      break
    case 403:
      console.error('403 - Não autenticado')
      break
    case 404:
      console.error('404 - Recurso não encontrado')
      break
    case 412:
      console.error(
        '412 - Problema ao obter dados com os parâmetros informados',
      )
      break
    case 415:
      console.error('415 - Tipo de midia não suportado')
      break
    case 500:
      console.error('500 - Erro de servidor')
      break
    default:
      break
  }
}

export default handleErrors
